import API from 'services/api';

export const deleteCalculationService = (serviceId: string) => {
  return API.delete(`/api/accommodation/calculations/services/${serviceId}`);
};
